import React, { Component } from 'react';
import { withTheme } from 'styled-components';
import PropTypes from 'prop-types';
import { isEqual } from 'lodash';
import { AbstractChart } from 'containers/charts/AbstractChart';
import ContentTile from 'components/atoms/layout/ContentTile';
import ContentHeader from 'components/atoms/layout/ContentHeader';
import helpers from 'helpers';
import { toolTipPointFormatterGenerator } from 'helpers/charts';

class TreemapChart extends Component {
    constructor(props) {
        super(props);
        this.chartRef = React.createRef();
    }

    shouldComponentUpdate(nextProps) {
        return !isEqual(nextProps.data, this.props.data);
    }

    render() {
        const { orderedColors } = this.props.theme;
        const { layoutAlgorithm, formatByType } = this.props;
        const { chartRef } = this;

        const seriesData = this.props.data.map((element, index) => {
            if (!element.color) {
                element.color = orderedColors[index % orderedColors.length];
            }
            return element;
        });

        const config = {
            meta: {
                title: this.props.title
            },
            chart: {
                margin: [0, 6, 0, 6]
            },
            exporting: helpers.commonExportingConfig(this.props.exportName),
            title: {
                text: null
            },
            credits: {
                enabled: false
            },
            tooltip: {
                pointFormatter: toolTipPointFormatterGenerator,
                followPointer: true,
                outside: true
            },
            series: [{
                type: 'treemap',
                data: seriesData,
                formatByType,
                dataLabels: {
                    style: { textOutline: '0px contrast' }
                }
            }]
        };

        if (layoutAlgorithm) {
            config.series[0].layoutAlgorithm = layoutAlgorithm;
        }

        return (
            <ContentTile padding={helpers.contentPadding('chart')}>
                <ContentHeader chartRef={chartRef} type={'chart'}>{this.props.title}</ContentHeader>
                <AbstractChart ref={chartRef} exportName={this.props.exportName} config={config} />
            </ContentTile>
        );
    }
}

TreemapChart.propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string.isRequired,
        value: PropTypes.number.isRequired,
        color: PropTypes.string
    })).isRequired,
    title: PropTypes.string.isRequired,
    exportName: PropTypes.string.isRequired,
    formatByType: PropTypes.string,
    layoutAlgorithm: PropTypes.oneOf(['strip', 'stripes', 'squarified'])
};

export default withTheme(TreemapChart);



// WEBPACK FOOTER //
// ./src/components/molecules/charts/TreemapChart.js